"use strict";

(function(z, Backbone){

    var ProjectsCorporateClientsModel = Backbone.Model.extend({
        urlRoot: "/api/corporateClients",
        validation: {
            name: [{
                required: true,
                msg: Translator.trans("js.error_message_contractsform_name_required")
            },{
                minLength: 4,
                msg: Translator.trans("js.error_message_orderform_customer_name_minlength")
            }],
            status: {
                required: true,
                msg: Translator.trans("js.error_message_serviceform_status_required")
            },
            cui: {
                required: true,
                msg: Translator.trans("js.error_message_serviceform_cui_required")
            },
            type: {
                required: true,
                msg: Translator.trans("js.error_message_vendorform_type_required")
            },
            county: [{
                required: true,
                msg: Translator.trans("js.error_message_showroomform_county_required")
            }],
            locality: [{
                required: true,
                msg: Translator.trans("js.error_message_showroomform_locality_required")
            }],
        },

        /**
         * Parses the response and returns the appropriate data
         * @param {Object} response The reponse
         * @return {Object} The data
         */
        parse: function(response){

            if( !_.isUndefined(response.data) ){

                return response.data;
            }

            return response;
        }
    });

    z.ProjectsCorporateClientsModel = ProjectsCorporateClientsModel;

})(window.z = window.z || {}, Backbone);
